import React, { useState } from "react";
import { useIntl } from "react-intl";
import classNames from "classnames";
import Tooltip from "@/component/Tooltip";


interface ClickableImgProps {
    src: string;
    alt?: string;
    square?: boolean;
    width?: number | string;
    height?: number | string;
}

const ClickableImg: React.FC<ClickableImgProps> = (props: ClickableImgProps) => {
    const { src, alt = "", square, width, height } = props;

    const intl = useIntl();

    const [isError, setIsError] = useState<boolean>(false);

    return (
        <Tooltip disable={isError}
                 message={intl.formatMessage({ id: "i00020" })}
        >
            <a href={src}
               target="_blank"
               rel="noopener noreferrer"
               aria-label={!alt ? intl.formatMessage({ id: "i00020" }) : undefined}
               aria-disabled={isError || undefined}
               tabIndex={isError ? -1 : undefined}
               onClick={isError ? (e) => { e.preventDefault(); } : undefined}
               style={isError ? { pointerEvents: "none" } : undefined}
            >
                <img src={src} alt={alt}
                     className={classNames(square ? "aspect-square" : "aspect-auto")}
                     style={isError
                        ? { width: "fit-content", height: "fit-content" }
                        : {
                            width,
                            height,
                            objectFit: !square ? "contain" : undefined
                        }}
                     onError={() => setIsError(true)}
                     onLoad={() => setIsError(false)}
                />
            </a>
        </Tooltip>
    );
};

export default ClickableImg;
